import React, { FunctionComponent } from 'react'
import { Box } from '@material-ui/core'
import Toolbar from './partials/Toolbar'
import List from './partials/List'
import { ParkingLotProvider } from './ParkingLotProvider'
import Message, { MessageProvider } from 'components/elements/Message'

type Props = {}
type Functions = {}
type AllProps = Props & Functions

const ParkingLot: FunctionComponent<AllProps> = ({}) => {
  return (
    <Box p={1.5}>
      <ParkingLotProvider>
        <MessageProvider>
          <Toolbar />
          <List />
          <Message />
        </MessageProvider>
      </ParkingLotProvider>
    </Box>
  )
}

export default ParkingLot
